import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { client_name, Theme } from "../../Helpers/request";

/* Note - Remove Below code and Import selected Home component  */
import ShowcaseHome from "./themes/showcase/ShowcaseHome";

/* ========================= */

const Home = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  /*========== Note - Remove Below code ==============*/
  const themes = {
    showcase: <ShowcaseHome />,
  };
  const DefaultHome = <ShowcaseHome />;
  /* ========================= */

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
        {/*Og Tags */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={metaDetails?.title} />
        <meta property="og:description" content={metaDetails?.description} />
        <meta property="og:url" content={metaDetails?.url} />
        <meta property="og:site_name" content={client_name?.c_name} />
      </Helmet>

      {/* Note - Remove Below code and add selected Home component like this <ShowcaseHome />   */}
      {themes[Theme] || DefaultHome}
    </>
  );
};

export default Home;
